<template>
  <div class="login-container">
    <!--引入粒子特效-->
    <div class="login-bg-box">
      <vue-particles color="#fff" :particle-opacity="0.7" :particles-number="60" shape-type="circle" :particle-size="4"
        lines-color="#fff" :lines-width="1" :line-linked="true" :line-opacity="0.4" :lines-distance="150"
        :move-speed="2" :hover-effect="true" hover-mode="grab" :click-effect="true" click-mode="push" class="lizi" />
    </div>

    <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
      label-position="left">

      <div class="title-container">
        <h3 class="title">数据可视化平台</h3>
      </div>

      <el-form-item prop="username">

        <span class="svg-container">
          <el-icon>
            <User />
          </el-icon>
        </span>
        <el-input ref="username" v-model="loginForm.username" placeholder="用户名" name="username" type="text" tabindex="1"
          auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <!-- <svg-icon icon-class="password" /> -->
          <el-icon>
            <Lock />
          </el-icon>
        </span>
        <el-input ref="password" v-model="loginForm.password" type="password" placeholder="密码"
          name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
       
      </el-form-item>

      <el-button :loading="loading" type="primary" size="large" style="width:100%;margin-bottom:30px;height:50px;font-size:16px;background: linear-gradient(45deg, #4481eb, #04befe);border:none;transition:all 0.3s ease;"
        @click.native.prevent="handleLogin" class="login-button">登录</el-button>

      <div class="tips">
        <!--        <span style="margin-right:20px;">username: admin</span>-->
        <!--        <span> password: any</span>-->
      </div>

    </el-form>
  </div>
</template>

<script setup>
import { validUsername } from '@/utils/validate'
import { userInfoStore } from '@/store/userInfo'
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const validateUsername = (rule, value, callback) => {
  if (!validUsername(value)) {
    callback(new Error('Please enter the correct user name'))
  } else {
    callback()
  }
}
const validatePassword = (rule, value, callback) => {
  if (value.length < 6) {
    callback(new Error('密码必须大于6位'))
  } else {
    callback()
  }
}

const _userInfoStore = userInfoStore()
const loginForm = reactive({
  username: '',
  password: '',
})
const loading = ref(false)
const loginRules = ref({
  username: [{ required: true, trigger: 'blur', validator: validateUsername }],
  password: [{ required: true, trigger: 'blur', validator: validatePassword }]
})

const loginFormRef = ref(null)
const handleLogin = () => {
  loginFormRef.value.validate(valid => {
    if (valid) {
      loading.value = true
      _userInfoStore.user_login(loginForm).then(res => {
        router.push({path: '/'})
        loading.value = false
      }).catch(_ => {
        loading.value = false
      })
    }
  })
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container {
    color: $cursor;
  }
}

.el-input__wrapper {
  background: transparent !important;
  box-shadow: none !important;
}

.el-input__wrapper {
  width: 100% !important;
}

.el-button {
  height: 50px;
}

.login-bg-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

/* reset element-ui css */
.login-container {
  width: 100vw;
  height: 100vh;

  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    background: transparent !important;

    input {
      background: transparent !important;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 8px;
      padding: 12px 15px;
      height: 47px;
      caret-color: #fff;
      color: #fff;
      font-size: 15px;
      outline: none !important;
      border: none !important;
      transition: all 0.3s ease;

      &::placeholder {
        color: rgba(255, 255, 255, 0.7);
      }

      &:-webkit-autofill {
        -webkit-text-fill-color: #fff !important;
        box-shadow: 0 0 0px 1000px transparent inset !important;
        transition: background-color 5000s ease-in-out 0s;
      }
    }

    .el-input__inner {
      background-color: transparent !important;
    }
  }

  .el-form-item {
    border: none;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    color: #fff;
    transition: all 0.3s ease;
    margin-bottom: 25px;
    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  //background-color: $bg;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 35px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    top: 30%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    // padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 47px;
    height: 47px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 28px;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
      color: #fff;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
